import React from 'react';
import { Card } from '../components/ui/card';
import { Award, Heart, Users } from 'lucide-react';

const About = () => {
  return (
    <div>
      {/* Hero Section */}
      <section 
        className="section section-blue"
      >
        <div className="container max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="premium-badge-yellow mb-6">Our Story</div>
          <h1 className="text-5xl md:text-6xl font-black mb-6">About Hope Tobacco</h1>
          <div className="section-divider" style={{ background: 'linear-gradient(90deg, var(--white) 0%, var(--marathon-red) 50%, var(--white) 100%)' }}></div>
          <p className="text-xl md:text-2xl mt-6" style={{ color: 'rgba(255, 255, 255, 0.95)' }}>
            Your trusted neighborhood destination for quality fuel, fresh food, and friendly service
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20" style={{ backgroundColor: 'var(--white)' }}>
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
            <div>
              <img 
                src="https://images.unsplash.com/photo-1585740452884-2a29a1d21514?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwzfHxnYXMlMjBzdGF0aW9ufGVufDB8fHx8MTc3MjQxNTMxOHww&ixlib=rb-4.1.0&q=85"
                alt="Marathon Gas Station"
                className="rounded-lg shadow-xl w-full h-auto object-cover"
              />
            </div>
            <div>
              <h2 className="text-3xl md:text-4xl font-black mb-6" style={{ color: 'var(--marathon-blue)' }}>
                Locally Owned & Operated
              </h2>
              <div className="section-divider-left"></div>
              <p className="text-lg mb-4 leading-relaxed" style={{ color: 'var(--gray-700)' }}>
                <strong>Hope Tobacco</strong> is a proud, locally owned business serving the Hope, Indiana community 
                for over 15 years. We're your one-stop shop featuring premium Marathon brand gasoline and 
                delicious Krispy Krunchy Chicken made fresh daily.
              </p>
              <p className="text-lg mb-4 leading-relaxed" style={{ color: 'var(--gray-700)' }}>
                As a trusted Marathon fuel provider, we offer top-tier gasoline with advanced detergent 
                additives for optimal engine performance. Our partnership with <strong>Krispy Krunchy Chicken</strong> 
                brings you authentic Cajun-inspired fried chicken that's hand-breaded and never frozen.
              </p>
              <p className="text-lg leading-relaxed" style={{ color: 'var(--gray-700)' }}>
                Our commitment goes beyond fuel and food—we focus on cleanliness, friendly service, 
                and creating a welcoming environment where our neighbors feel at home. When you stop at 
                Hope Tobacco, you're supporting a local business that cares about this community.
              </p>
            </div>
          </div>

          {/* Values */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16">
            <Card className="professional-card text-center">
              <div 
                className="w-20 h-20 mx-auto mb-6 rounded-2xl flex items-center justify-center"
                style={{ 
                  background: 'linear-gradient(135deg, var(--marathon-blue) 0%, var(--marathon-red) 100%)',
                  color: 'var(--white)'
                }}
              >
                <Award size={40} />
              </div>
              <h3 className="text-xl font-bold mb-3" style={{ color: 'var(--gray-900)' }}>
                Quality First
              </h3>
              <p style={{ color: 'var(--gray-600)' }}>
                From Marathon fuel to hand-breaded chicken, we never compromise on quality.
              </p>
            </Card>

            <Card className="professional-card text-center">
              <div 
                className="w-20 h-20 mx-auto mb-6 rounded-2xl flex items-center justify-center"
                style={{ 
                  background: 'linear-gradient(135deg, var(--marathon-blue) 0%, var(--marathon-red) 100%)',
                  color: 'var(--white)'
                }}
              >
                <Heart size={40} />
              </div>
              <h3 className="text-xl font-bold mb-3" style={{ color: 'var(--gray-900)' }}>
                Community Focused
              </h3>
              <p style={{ color: 'var(--gray-600)' }}>
                Locally owned and proud to serve our neighbors in Hope and surrounding areas.
              </p>
            </Card>

            <Card className="professional-card text-center">
              <div 
                className="w-20 h-20 mx-auto mb-6 rounded-2xl flex items-center justify-center"
                style={{ 
                  background: 'linear-gradient(135deg, var(--marathon-blue) 0%, var(--marathon-red) 100%)',
                  color: 'var(--white)'
                }}
              >
                <Users size={40} />
              </div>
              <h3 className="text-xl font-bold mb-3" style={{ color: 'var(--gray-900)' }}>
                Friendly Service
              </h3>
              <p style={{ color: 'var(--gray-600)' }}>
                Our team is dedicated to making your visit quick, easy, and pleasant.
              </p>
            </Card>
          </div>
        </div>
      </section>

      {/* Krispy Krunchy Section */}
      <section className="section section-light">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <div className="premium-badge-yellow mb-6">
              Proud Partner of Krispy Krunchy Chicken
            </div>
            <h2 className="text-3xl md:text-4xl font-black mb-4" style={{ color: 'var(--marathon-blue)' }}>
              Fresh, Hand-Breaded Chicken Daily
            </h2>
            <div className="section-divider"></div>
            <p className="text-lg max-w-3xl mx-auto mt-6 leading-relaxed" style={{ color: 'var(--gray-700)' }}>
              Krispy Krunchy Chicken is known for its bold Cajun flavors and signature crispy crunch. 
              Every piece is hand-breaded and made fresh throughout the day—never frozen, always delicious. 
              Whether you're grabbing lunch, feeding the family, or planning for a gathering, we've got you covered.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <img 
              src="https://images.pexels.com/photos/12118977/pexels-photo-12118977.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
              alt="Krispy Krunchy Chicken Meal"
              className="professional-image w-full h-72 object-cover"
            />
            <img 
              src="https://images.unsplash.com/photo-1694853651800-3e9b4aa96a42?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHw0fHxmcmllZCUyMGNoaWNrZW58ZW58MHx8fHwxNzcyNDE2MDYxfDA&ixlib=rb-4.1.0&q=85"
              alt="Fresh Fried Chicken"
              className="professional-image w-full h-72 object-cover"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
